<template>
  <button ref="btn" @click="showIndicator" class="overflow-hidden relative elevated-button h-10 flex items-center justify-center
    transition-colors duration-200
    text-white rounded-[1.25rem]" :class="[{
      'px-6': !($slots.icon),
      'pl-4 pr-6': $slots.icon,
    },
    colors[color][status],
    ]">
    <div v-if="status === 'loading'" class="absolute">
      <SpinnerIcon class="h-6 w-6 animate-spin mr-1 text-white stroke-white fill-white" />
    </div>

    <div class="flex" :class="{'opacity-0': status === 'loading'}">
      <div v-if="$slots.icon"
        class="elevated-button__icon pr-2 flex items-center justify-center">
        <slot name="icon"></slot>
      </div>

      <slot></slot>
      <div ref="indicator" class="absolute z-10 opacity-0 elevated-button__indicator
         lef-0 w-5 h-5 rounded-full
         transform-origin-center pointer-events-none"
        :class="indicatorColors[color]">
      </div>
    </div>

  </button>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import { useRouter, RouteLocationNamedRaw } from 'vue-router'
import SpinnerIcon from '../icons/SpinnerIcon.vue';
const indicator = ref<HTMLElement | undefined>(undefined);
const btn = ref<HTMLElement | undefined>(undefined);

// Define ButtonStatus type
type ButtonStatus = 'default' | 'hover' | 'active' | 'pressed' | 'loading';
type Colors = 'primary' | 'red';


const props = withDefaults(defineProps<{
  to?: RouteLocationNamedRaw
  color?: Colors
  status?: ButtonStatus
}>(), {
  to: undefined,
  color: 'primary',
  status: 'default',
})


const colors: Record<Colors, Record<ButtonStatus, string>> = {
  "primary": {
    "default": "bg-apex-blue-400",
    "hover": "hover:bg-apex-blue-500",
    "active": "active:bg-apex-blue-600",
    "pressed": "bg-apex-blue-600",
    "loading": "bg-apex-blue-400",
  },
  "red": {
    "default": "bg-red-500",
    "hover": "hover:bg-red-600",
    "active": "active:bg-red-600",
    "pressed": "bg-red-600",
    "loading": "bg-red-500",
  }
}

const indicatorColors = {
  "primary": "bg-apex-blue-800/30",
  "secondary": "bg-gray-600/10",
  "red": "bg-red-800/30",
}

const router = useRouter();
const showIndicator = (e: any) => {
  if (!indicator.value || !btn.value || indicator.value == undefined) return;

  const btnRect = btn.value.getBoundingClientRect();
  const clickX = e.clientX - btnRect.left;
  const clickY = e.clientY - btnRect.top;

  // set the center of the indicator to the click position
  indicator.value.style.left = `${clickX}px`;
  indicator.value.style.top = `${clickY}px`;

  // Center the indicator and scale it
  indicator.value.style.transform = 'translate(-50%, -50%) scale(10)';
  indicator.value.style.opacity = '1';


  setTimeout(() => {
    if (indicator.value != undefined) {
      indicator.value.style.opacity = '0';
      indicator.value.style.transform = 'translate(-50%, -50%) scale(0)';
    }

    if (props.to) {
      router.push(props.to);
    }

    btn.value?.blur();
  }, 250);
}
</script>

<style scoped>
.elevated-button__indicator {
  transition: opacity 0.5s, transform 0.5s;
}
</style>